import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Stack } from '@hub/stack';
import { LinkBox } from '@hub/link';
import { FeatureDetails } from './feature-details';
import { FeatureImage } from './feature-image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Feature = _ref => {
  let {
    title,
    link,
    body,
    onClick,
    image
  } = _ref;
  const commonStackProps = {
    sx: {
      width: 'size-xl',
      maxHeight: 'size-full',
      display: ['none', null, null, 'initial']
    },
    gap: 'spacing-md',
    shouldWrapChildren: false
  };
  return link ? /*#__PURE__*/_jsx(LinkBox, {
    "data-id": "mega-menu_feature_Feature_LinkBox",
    children: /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({}, commonStackProps), {}, {
      "data-id": "mega-menu_feature_Feature_LinkBox_Stack",
      children: [/*#__PURE__*/_jsx(FeatureImage, {
        image: image,
        "data-id": "mega-menu_feature_Feature_Stack_FeatureImage"
      }), /*#__PURE__*/_jsx(FeatureDetails, {
        title: title,
        body: body,
        link: link,
        onClick: onClick,
        "data-id": "mega-menu_feature_Feature_Stack_FeatureDetails"
      })]
    }))
  }) : /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({}, commonStackProps), {}, {
    "data-id": "mega-menu_feature_Feature_Stack",
    children: [/*#__PURE__*/_jsx(FeatureImage, {
      image: image,
      "data-id": "mega-menu_feature_Feature_Stack_FeatureImage"
    }), /*#__PURE__*/_jsx(FeatureDetails, {
      title: title,
      body: body,
      "data-id": "mega-menu_feature_Feature_Stack_FeatureDetails"
    })]
  }));
};